import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './store'
// Design-system theme (tokens + base reset/utilities). Loaded once at the root
// so every screen resolves the Console design-system classes.
import './theme/tokens.css'
import './theme/base.css'
import { applyTheme, initThemeWatcher } from './theme/themePref'
import './index.css';
import App from './App';
import UpdateBanner from './components/UpdateBanner';
import { watchBackendVersion } from './backendVersion';

// Theme selection: honor the persisted 'gw-theme' choice (light | dark | system).
// Applied before first paint so the correct palette shows without a flash; the watcher
// keeps 'system' in sync when the OS flips light↔dark. (Toggle lives in Display.)
applyTheme()
initThemeWatcher()

// Dev-only handle: exposes the Redux store on window so the 'direct' accountType
// experience can be previewed from the console until the super-user Subscribers
// screen (the real set-point) ships. Guarded by NODE_ENV → stripped from prod builds.
//   window.__gwStore.dispatch({type:'auth/setAuthState',payload:{field:'accountType',value:'direct'}})
if (process.env.NODE_ENV === 'development') {
  window.__gwStore = store
}

// Every API response names the backend build answering it; keep the header's API label on it.
watchBackendVersion(store)

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <UpdateBanner />
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
